/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".document-scan-success[_ngcontent-%COMP%]   .img-success[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center}.document-scan-success[_ngcontent-%COMP%]   .img-success[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:216px}.document-scan-success[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]{color:#007a47;font-size:24px;font-weight:300;line-height:32px;letter-spacing:0;margin-top:48px;margin-bottom:24px}"];
export { styles as styles };
